import { render, staticRenderFns } from "./ClientsCompanyAprovals.vue?vue&type=template&id=54a5ffd7&scoped=true&"
import script from "./ClientsCompanyAprovals.vue?vue&type=script&lang=js&"
export * from "./ClientsCompanyAprovals.vue?vue&type=script&lang=js&"
import style0 from "./ClientsCompanyAprovals.vue?vue&type=style&index=0&id=54a5ffd7&prod&scoped=true&lang=css&"
import style1 from "./ClientsCompanyAprovals.vue?vue&type=style&index=1&id=54a5ffd7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5ffd7",
  null
  
)

export default component.exports